import { useSobrePageModel } from '@/components/about/sobre-page/sobre-page.model'
import { SobrePageView } from '@/components/about/sobre-page/sobre-page.view'

export function SobrePageViewModel() {
  const model = useSobrePageModel()
  return <SobrePageView {...model} />
}
